import LoadMoreButton from 'components/load-more-button';

export type LoadMoreVirtualListFooterProps = {
  context?: {
    per?: number;
    total?: number;
    loading?: boolean;
    loadedNum?: number;
    loadMore: () => void;
  };
};

const LoadMoreVirtualListFooter: React.FC<LoadMoreVirtualListFooterProps> = (props) => {
  const { loadMore, loadedNum = 0, per = 0, total = 0, loading } = props?.context ?? {};

  return loadedNum !== total ? (
    <LoadMoreButton
      per={per}
      total={total}
      loading={loading}
      onClick={loadMore}
      loadedNum={loadedNum}
    />
  ) : null;
};

export default LoadMoreVirtualListFooter;
